/** @API query to get api */
export const API = "/api";

/** List of all available api queries */
export default {
  // Auth:
  auth: "/auth/",

  // Audiences:
  audiences: "/audience/audiences",
  audienceFile: "/audience/postal-code/",
  audienceDemographics: "/audience/key-demographic/",
  audiencesCategories: "/audience/categories",
  audiencesSubcategories: "/audience/subcategories",
  audiencesPresets: "/audience/presets",
  audiencesVariables: "/audience/variables",
  countriesWithAudience: "/userprofile/countries",
  audienceStats: "/audience/calculate-audience/",
  presetStats: "/audience/presets/",
  audienceTags: "/audience/calculate-word-cloud/",
  audienceSamMap: "/audience/retrieve-sam/",
  // audienceMap: "/audience/heat-map/",
  audienceMap: "/audience/retrieve-map-locations/",
  audiencePersonaDescription: "/audience/persona-description/",
  clients: "/client/clients",
  clientsUpgrade: "/client/clients/upgrade",
  verticals: "/client/verticals",
  audienceCheckSharing: "/audience/audiences/check-sharing",
  audienceShare: "/audience/audiences/share",

  audienceDuplicate: "/audience/audiences/copy",

  audiencesRestoreAll: "/audience/audiences/restore-all",
  audiencesRestore: "/audience/audiences/restore",
  audiencesRemoveAll: "/audience/audiences/delete-all",

  // audienceFetchMapLayout: "/regions/country-shape",

  // Notifications:
  notifications: "/notification/notifications",

  // Users:
  userProfile: "/userprofile/userprofiles",
  userProfileUpdate: "/userprofile/profile-update",
  userValidate: "/userprofile/validate/",
  userRegister: "/userprofile/register/",
  userBillingInfo: "/userprofile/billings",
  createUserBilling: "/userprofile/create-billing/",
  userActivate: "/userprofile/activate/",
  userResetPassword: "/userprofile/reset-password/",
  userRestorePassword: "/userprofile/reset-password/new-password",
  invite: "/userprofile/invite/invitation",
  inviteInfo: "/userprofile/invite/invited-user-id",
  inviteActivate: "/userprofile/invite/activate",
  deactivated: "/userprofile/deactivated",
  userChangeRole: "/userprofile/profile-update/change-role",
  userAvatar: "/userprofile/photo-upload/",
  regions: "/regions",

  // Company:
  companyProfileUpdate: "/userprofile/company",
  companyAvatar: "/userprofile/company-logo/",

  // Subscriptions:
  subscriptionSelect: "/subscription/choose-plan/",
  subscription: "/subscription/",

  // Stripe:
  stripeCustomer: "/payment/customer-create/",
  stripeSubscription: "/payment/subscription-create/",
  stripeCards: "/payment/cards",
  stripeCardsSetDefault: "/payment/cards/set-default-card",
  stripeCustomers: "/payment/customers",
  paymentStatistics: "/subscription/dashboard/",

  // Platforms:
  /* eslint no-irregular-whitespace: ["error", { "skipTemplates": true }] */
  /* eslint-env es6 */
  audienceCompliance: ({ id, type }) =>
    `/platforms/audience-compliance/?${type}=${id}`,

  // Fb:
  platformFBAccessToken: "/platforms/facebook/access-token",
  platformFBCheckAuth: "/platforms/facebook/valid-token",
  platformFBPush: "/platforms/facebook/push",
  platformFBLogout: "/platforms/facebook/logout",
  platformFBAdAccounts: "/platforms/facebook/adaccounts",
  /* eslint no-irregular-whitespace: ["error", { "skipTemplates": true }] */
  /* eslint-env es6 */
  platformFBCampaigns: adAccountId =>
    `/platforms/facebook/campaigns/${adAccountId}`,
  platformFBAdSets: campaignId => `/platforms/facebook/adsets/${campaignId}`,

  // GoogleAds:
  platformGoogleAdsRefreshToken: "/platforms/google-ads/refresh-token",
  platformGoogleAdsCheckAuth: "/platforms/google-ads/valid-token",
  platformGoogleAdsPush: "/platforms/google-ads/push",
  platformGoogleAdsLogout: "/platforms/google-ads/logout",
  /* eslint no-irregular-whitespace: ["error", { "skipTemplates": true }] */
  /* eslint-env es6 */
  platformGoogleAdsCustomers: "/platforms/google-ads/accessible-customers",
  platformGoogleAdsCampaigns: customerId =>
    `/platforms/google-ads/customer-campaigns/${customerId}`,

  // Google:
  platformGoogleDownload: "/platforms/dv360/download-locations",

  // Adform:
  platformAdformAccessToken: "/platforms/adform/access-token",
  platformAdformAuthorize: "/platforms/adform/authorize",
  platformAdformPush: "/platforms/adform/push",
  platformAdformCheckAuth: "/platforms/adform/valid-token",
  platformAdformLogout: "/platforms/adform/logout",
  /* eslint no-irregular-whitespace: ["error", { "skipTemplates": true }] */
  /* eslint-env es6 */
  platformAdformCampaigns: "/platforms/adform/campaigns",
  platformAdformLineitems: campaignId =>
    `/platforms/adform/lineitems?campaign_id=${campaignId}`,

  // Ttd
  platformTtdPush: "/platforms/ttd/push",

  // Snapchat
  platformSnapchatRefreshToken: "/platforms/snapchat/access-token",
  platformSnapchatCheckAuth: "/platforms/snapchat/valid-token",
  platformSnapchatPush: "/platforms/snapchat/push",
  platformSnapchatLogout: "/platforms/snapchat/logout",
  platformSnapchatAuthorize: "/platforms/snapchat/authorize",
  platformSnapchatOrganizations: "/platforms/snapchat/organizations",

  // Xandr
  platformXandrCheckAuth: "/platforms/xandr/valid-token",
  platformXandrLogout: "/platforms/xandr/logout",
  platformauthXandr: "/platforms/xandr/authorize",
  platformXandrPush: "/platforms/xandr/push",
  platformXandrAdvertisers: "/platforms/xandr/advertisers",
  platformXandrLineItems: "/platforms/xandr/line-items",
  platformXandrDownload: "/platforms/xandr/download-locations",
  platformXandrDownloadZIP: "/platforms/xandr/download-zips",

  // SmartClip:
  platformSmartClipCheckAbility: "/platforms/smartclip/check-download-ability",
  platformSmartClipDownload: "/platforms/smartclip/download-zips",
  platformPostalCodesDownload: "/platforms/postal-codes/download",
  platformLlCoordinatesDownload: "/platforms/ll-coordinates/download",
  // /* eslint no-irregular-whitespace: ["error", { "skipTemplates": true }] */
  // /* eslint-env es6 */
  platformSnapchatAdAccounts: organizationId =>
    `/platforms/snapchat/organization/${organizationId}/adaccounts`,
  platformSnapchatCampaigns: adAccountId =>
    `/platforms/snapchat/adaccount/${adAccountId}/campaigns`,
  platformSnapchatAdSets: campaignId =>
    `/platforms/snapchat/campaign/${campaignId}/adsquads`
};
